import React, { memo } from 'react';
import { Building2, GraduationCap, Calendar, Users, User } from 'lucide-react';
import { Button } from './ui/Button';
export function WhoWeServe() {
  const audiences = [{
    icon: <Building2 className="w-8 h-8" data-id="element-281" />,
    title: 'Businesses & Brands',
    description: 'Corporate apparel, uniforms, promotional products, and branded merchandise.',
    accentColor: 'pink' as const
  }, {
    icon: <GraduationCap className="w-8 h-8" data-id="element-282" />,
    title: 'Schools & Teams',
    description: 'Team uniforms, spirit wear, athletic apparel, and school merchandise.',
    accentColor: 'yellow' as const
  }, {
    icon: <Calendar className="w-8 h-8" data-id="element-283" />,
    title: 'Events & Fundraisers',
    description: 'Custom event shirts, fundraising merchandise, and commemorative apparel.',
    accentColor: 'teal' as const
  }, {
    icon: <Users className="w-8 h-8" data-id="element-284" />,
    title: 'Camps & Organizations',
    description: 'Camp designs, organization apparel, and group orders of all sizes.',
    accentColor: 'pink' as const
  }, {
    icon: <User className="w-8 h-8" data-id="element-285" />,
    title: 'Individuals & Small Orders',
    description: 'Personalized gifts, custom designs, and small batch orders welcome.',
    accentColor: 'yellow' as const
  }];
  const accentColors = {
    pink: 'text-wh-pink bg-pink-50',
    yellow: 'text-wh-yellow bg-yellow-50',
    teal: 'text-wh-teal bg-teal-50'
  };
  return <section className="py-16 bg-gray-50 border-t border-gray-100" data-id="element-286">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-287">
        <div className="text-center mb-12" data-id="element-288">
          <span className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-3" data-id="element-289">
            Who We Help
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3" data-id="element-290">
            Who We Serve
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-291">
            From large corporate orders to individual custom projects, we
            deliver quality results for every customer.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-10" data-id="element-292">
          {audiences.map((audience, index) => <div key={index} className="bg-white p-6 rounded-xl border border-gray-100 shadow-sm hover:border-gray-200 hover:shadow-md transition-all duration-300" data-id="element-293">
              <div className={`w-14 h-14 rounded-lg ${accentColors[audience.accentColor]} flex items-center justify-center mb-4`} data-id="element-294">
                {audience.icon}
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-295">
                {audience.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed" data-id="element-296">
                {audience.description}
              </p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-297">
          <Button variant="primary" size="lg" data-id="element-298">
            Start Your Custom Project
          </Button>
          <p className="text-sm text-gray-500 mt-3" data-id="element-299">
            We work with projects of all sizes — from one-offs to large runs.
          </p>
        </div>
      </div>
    </section>;
}